// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-alert[data-v-5a644586]{margin:10px 0 0 0}", ""]);
// Exports
module.exports = exports;
